import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import moment from "moment";
import { Knob } from "primereact/knob";
import { FileUpload } from "primereact/fileupload";
import { Tooltip } from "primereact/tooltip";
import { RadioButton } from "primereact/radiobutton";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { addLocale } from "primereact/api";
import { Tag } from "primereact/tag";

import { getListaOtrosFormularios, crearOtrosFormulario, eliminarOtrosFormulario, uploadDocumentoOtros, uploadDocumentoPDFMasivoOtros, statusDocumentoPDFMasivoOtros, copyDocumento, setMedico, getDataRevTemplanteMasivo } from "../../service/OtroFormulario";
import { useDispatch, useSelector } from "react-redux";
import { loading } from "../../actions";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { getDataFormulario, getDataRevTemplante } from "../../service/Formulario";
import { Formulario } from "../../components/Formulario";
import { generateDocument, generateDocumentMasivo } from "../../components/GenerateDocument";
import { ScrollPanel } from "primereact/scrollpanel";

import { Steps } from "primereact/steps";
import "./StepsDemo.css";
import classNames from "classnames";
import { ToggleButton } from "primereact/togglebutton";
import { FiltroNivelCurso } from "../../components/FiltroNivelCurso";

import { useHistory } from "react-router-dom";
import { accionPermiso } from "../../utilities/Seguridad";
import { Routes, Route, useParams } from "react-router-dom";
import { CalendarDemo } from "../CalendarDemo";
import { Badge } from "primereact/badge";
import { isNotVacioNull, isEmail, isRun, isLetrasEspacio, minMax, isNumerico, isTelefono, getResultValidar } from "../../utilities/Validate";

export const PageOtro = () => {
    let idOtro = useParams();
    const dispatch = useDispatch();

    let ColegioData = {
        id: null,
        idmatricula: null,
        idalumno: null,
        fecha_matricula: "",
        rbd: "",
        colegio: "",
        grado: "",
        run: "",
        digito_verificador: "",
        nombres: "",
        apellido_paterno: "",
        apellido_materno: "",
        diagnostico: "",
        tipo_nee: "",
        observacion: "",
        adicional: "",
    };

    let medico = {
        nombres: "",
        rut: "",
        nro_reg_prof: "",
        especialidad: "",
        procedencia: "",
        fono_email: "",
        fecha_eval: "",
        fecha_rev: "",
    };

    let medicoValidate = {
        nombres: { estado: null, mensaje: "Valor requerido con longitud min. 5,max. 100", validar: isLetrasEspacio, minmax: true, min: 5, max: 100 },
        rut: { estado: null, mensaje: "Error formato run", validar: isRun, minmax: false },
        nro_reg_prof: { estado: null, mensaje: "Valor requerido", validar: isNumerico, minmax: false },
        especialidad: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        procedencia: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        fono_email: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        fecha_eval: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        fecha_rev: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
    };

    const [dataTable, setDataTable] = useState(ColegioData);
    const [dataTableFilter, setDataTableFilter] = useState(ColegioData);
    const [globalFilter, setGlobalFilter] = useState("");
    const [visibleFudai, setVisibleFudai] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [displayResponsive, setDisplayResponsive] = useState(false);
    const [selectRow, setSelectRow] = useState(null);
    const [countDelete, setCountDelete] = useState(0);
    const [countInfoPDFMasivo, setCountInfoPDFMasivo] = useState(0);
    const [visibleDialog, setVisibleDialog] = useState(false);
    //const [dataFormulario, setDataFormulario] = useState({});
    const [city, setCity] = useState(null);
    const [medicoData, setMedicoData] = useState(medico);
    const [medicoDataValidate, setMedicoDataValidate] = useState(medicoValidate);
    const [submitted, setSubmitted] = useState(false);
    const [inputAdd, setInputAdd] = useState({ value: "", enabled: true, estado: true });
    const [displayResponsivePDF, setDisplayResponsivePDF] = useState(false);
    const [array, setArray] = useState([]);
    const [subir, setSubir] = useState(false);

    const toast = useRef(null);
    const dataFormulario = useRef([]);
    // Reset Filtros Curso y grado
    const filtroRef = useRef(null);

    const rowData = useRef(null);

    const [ini, setini] = useState(0);

    addLocale("es", {
        firstDayOfWeek: 1,
        dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
        dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
        monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
        today: "Hoy",
        clear: "Limpiar",
    });

    // Permisos
    const history = useHistory();
    const permisos = useRef({ superusuario: false, acciones: [] });
    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    try {
        permisos.current.superusuario = usuario.superusuario;
        permisos.current.acciones = usuario.permisos.otros_formularios[idOtro.idOtro]["acciones"];
    } catch (error) {
        permisos.current.acciones = [];
    }
    //----------------------------

    useEffect(() => {
        loadListaMatricula();
        statusDocumentoMasivoPDF(false);
        //if (accionPermiso(permisos, 'fud_rev_ver')) {
        //    loadListaMatricula();
        //} else {
        //    history.push('/Acceso')
        //}
    }, [anio]);

    const getFiltroNivelCurso = useCallback(
        (data) => {
            if (data.es_nivel) {
                if (data.idnivel == 0) {
                    setDataTableFilter(dataTable);
                } else {
                    setDataTableFilter(dataTable.filter((o) => o.idnivel == data.idnivel));
                }
            } else {
                if (data.id == 0) {
                    setDataTableFilter(dataTable.filter((o) => o.idnivel == data.idnivel));
                } else {
                    setDataTableFilter(dataTable.filter((o) => o.idgrado == data.id &&
                        o.idnivel == data.idnivel));
                }
            }
        },
        [dataTableFilter]
    )

    const cerrar = () => {
        setVisibleFudai(false);
        toast.current?.show({ severity: "success", summary: "OK", detail: "Formulario Cerrado", life: 8000 });
        //window.scrollTo({ top: 0, behavior: 'smooth' });
        window.scrollTo({ top: 0 });
        loadListaMatricula();
    };

    const loadListaMatricula = async () => {
        if (colegio.id !== undefined && anio.anio !== undefined) {
            dispatch(loading(true));
            filtroRef.current.click();
            var data = await getListaOtrosFormularios(colegio.id, anio.anio, usuario.token, idOtro.idOtro);
            if (data.error == 0) {
                setDataTable(data.matricula_pie);
                setDataTableFilter(data.matricula_pie);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }

            dispatch(loading(false));
        } else {
            setDataTable([]);
            setDataTableFilter([]);
        }
        setSelectRow(null);
        setCountDelete(0);
    };

    const confirmDelete = (row) => {
        confirmDialog({
            message: "¿Estas seguro que deseas eliminar el formulario?",
            header: "Eliminar Formulario",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-success",
            accept: () => eliminar(row),
        });
    };

    const eliminar = async (row) => {
        dispatch(loading(true));
        var data = await eliminarOtrosFormulario(usuario.token, row.id_otro_formulario);
        if (data.error == 0) {
            loadListaMatricula();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }

        dispatch(loading(false));
    };

    const exportExcel = () => {
        let dataExportar = [];
        dataTableFilter?.map((obj) => {
            let o = { ...obj };
            delete o.id;
            delete o.idmatricula;
            delete o.idalumno;
            delete o.digito_verificador;
            delete o.iddiagnostico;
            delete o.idtipo_nee;
            delete o.formulario_fudei;
            delete o.formulario_reevaluacion;
            dataExportar.push(o);
        });
        import("xlsx").then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(dataExportar);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
            saveAsExcelFile(excelBuffer, "Fudei_Matricula");
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then((FileSaver) => {
            let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            let EXCEL_EXTENSION = ".xlsx";
            const data = new Blob([buffer], {
                type: EXCEL_TYPE,
            });
            FileSaver.saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
        });
    };

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const bodyTemplateDate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field] === null ? "--" : moment(data[props.field]).format("DD/MM/YYYY")}
            </>
        );
    }

    useEffect(() => {
        if (array.length > 0) {
            const hasEstadoUno = array.some(item => item.estado === 1);
            if (hasEstadoUno) {
                setSubir(true);
            } else {
                setSubir(false);
            }
            //files.options.clear();
        } else {
            setSubir(false)
        }
        setCountInfoPDFMasivo(array.length)
    }, [array]);

    const dialogFileMasivo = () => {
        setArray([]);
        setDisplayResponsivePDF(true);
        statusDocumentoMasivoPDF(true);
    }

    const downloadFileMasivo = async () => {
        dispatch(loading(true));
        let arrayIds = selectRow.map(function (item) {
            return item.id_otro_formulario;
        });

        let data = await getDataRevTemplanteMasivo(usuario.token, colegio.id, anio.anio, idOtro.idOtro, JSON.stringify(arrayIds));
        if (data.error == 0) {
            await generateDocumentMasivo(data.data);
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
        dispatch(loading(false));
    }

    const showMedico = () => {
        setVisibleDialog(true);
    }

    const dataTableHeader = (
        <div className="p-formgrid p-grid p-col-12 p-fluid p-p-0">
            <div className="p-col-12 p-md-6 p-lg-2 p-mt-5">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} className="p-mr-3" placeholder="Buscar..." />
                </span>
            </div>
            <div className="p-col-12 p-md-6 p-lg-3">
                <FiltroNivelCurso getFiltroNivelCurso={getFiltroNivelCurso} reset={filtroRef} />
            </div>
            <div className="p-col-8 p-md-2 p-lg-3 p-offset-4 p-mt-3" style={{ textAlign: "right" }}>


                {idOtro.idOtro === "valoracion_salud" && countDelete > 0 && accionPermiso(permisos, "descarga_masivo_pdf") ? (
                    <>
                        <Tooltip target=".custom-target-icon" />

                        <i className="custom-target-icon pi pi-file-pdf mr-4 p-text-secondary p-overlay-badge" data-pr-tooltip="Descargar" data-pr-position="bottom" style={{ fontSize: "2rem", marginRight: "1.5rem", cursor: "pointer" }} onClick={downloadFileMasivo}>
                            <Badge value={countDelete} severity="danger"></Badge>
                        </i>
                        <i className="custom-target-icon pi pi-user-plus mr-4 p-text-secondary p-overlay-badge" data-pr-tooltip="+ Médico" data-pr-position="bottom" style={{ fontSize: "2rem", marginRight: "1.5rem", cursor: "pointer" }} onClick={showMedico}>
                            <Badge value={countDelete} severity="danger"></Badge>
                        </i>
                    </>
                ) : (
                    ""
                )}
                {idOtro.idOtro === "valoracion_salud" && accionPermiso(permisos, "subir_masivo_pdf") ? (
                    <>
                        <Tooltip target=".custom-target-icon" />
                        <i className="custom-target-icon pi pi-file-pdf mr-4 p-text-secondary p-overlay-badge" data-pr-tooltip="Importar" data-pr-position="bottom" style={{ fontSize: "2rem", marginRight: countInfoPDFMasivo > 0 ? '1.5rem' : '0.5rem', cursor: "pointer" }} onClick={dialogFileMasivo}>
                            {countInfoPDFMasivo > 0 ? <Badge value={countInfoPDFMasivo} severity="info"></Badge> : ''}
                        </i>

                    </>
                ) : (
                    ""
                )}
                {accionPermiso(permisos, "fud_rev_exportar") ? <Button type="button" icon="pi pi-file-excel" onClick={exportExcel} className="p-button-success mr-2 p-mr-1" data-pr-tooltip="Descargar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }} /> : ""}
                <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={loadListaMatricula} tooltip="Refresh" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button>

            </div>
        </div>
    );

    const data = useRef(null);
    const tipo = useRef(null);

    const confirmCrear = (row) => {
        confirmDialog({
            message: "Estas seguro que deseas crear el Formulario?",
            header: "Confirmar!",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-success",
            accept: () => crear(row),
        });
    };

    const showCrearEditar = (row) => {
        if (row.id_otro_formulario === null || row.id_otro_formulario === "") {
            confirmCrear(row);
        } else {
            showFormulario(row, true);
        }
    };

    const showFormulario = (row, editar) => {
        data.current = row;
        tipo.current = false;
        setVisibleFudai(true);
        setActiveIndex(0);
        loadDataFormulario(row, editar);
    };

    const crear = async (row) => {
        dispatch(loading(true));
        var data = await crearOtrosFormulario(usuario.token, row.id, idOtro.idOtro);
        if (data.error == 0) {
            loadListaMatricula();
            row.id_otro_formulario = data.id_otro_formulario;
            showFormulario(row, true);
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }

        dispatch(loading(false));
    };

    const copiar = async (row) => {

        dispatch(loading(true));
        var data = await copyDocumento(usuario.token, row.id, idOtro.idOtro);
        if (data.error == 0) {
            loadListaMatricula();
            // row.id_otro_formulario = data.id_otro_formulario;
            // showFormulario(row, true);
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }

        dispatch(loading(false));
    };

    const monthNavigatorTemplate = (e) => {
        return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} style={{ lineHeight: 1 }} />;
    };

    const yearNavigatorTemplate = (e) => {
        return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} className="ml-2" style={{ lineHeight: 1 }} />;
    };

    const downloadFile = async (row) => {
        dispatch(loading(true));
        if (row.archivo === "") {
            let data = await getDataRevTemplante(usuario.token, row.id_otro_formulario);
            if (data.error == 0) {
                generateDocument(idOtro.idOtro, data.data, null);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "OK", summary: "Data Formulario", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
        } else {
            generateDocument(null, null, row.archivo);
        }
        dispatch(loading(false));
    };


    const hideFormulario = () => {
        setVisibleFudai(false);
    };

    const actionBodyHerramienta = (rowData) => {
        let id_otro_formulario = rowData.id_otro_formulario;
        let esNull = id_otro_formulario === null || id_otro_formulario === "" ? true : false;

        let subir = esNull && rowData.archivo === "" ? true : false;
        let crearEditar = rowData.archivo === "" ? true : false;
        let elminar = !esNull || rowData.archivo !== "" ? true : false;
        let replicar = esNull && rowData.archivo === "" ? true : false;
        let ver = !esNull && rowData.archivo === "" ? true : false;
        let certificado = esNull && rowData.archivo === "" ? true : false;

        if (rowData.estado === 3) {
            crearEditar = false;
        }

        return (
            <React.Fragment>
                <div className="actions">
                    {accionPermiso(permisos, "crear") && idOtro.idOtro !== "certificado_nacimiento" ? (
                        <Button icon="pi pi-file" className="p-button-rounded p-button-success p-mr-2" disabled={!crearEditar} tooltip={esNull ? "Crear" : "Editar"} tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }} onClick={() => showCrearEditar(rowData)} />
                    ) : (
                        ""
                    )}
                    {accionPermiso(permisos, "ver") && idOtro.idOtro !== "certificado_nacimiento" ? (
                        <Button icon="pi pi-eye" className="p-button-rounded p-button-info p-mr-2" disabled={!ver} tooltip="Ver" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }} onClick={() => showFormulario(rowData, false)} />
                    ) : (
                        ""
                    )}
                    {accionPermiso(permisos, "certificado") && idOtro.idOtro === "certificado_nacimiento" ? (
                        <Button icon="pi pi-reply" className="p-button-rounded p-mr-2" tooltip="Certificado" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }} onClick={() => window.open("https://www.registrocivil.cl/principal/servicios-en-linea", "_blank")} />
                    ) : (
                        ""
                    )}
                    {accionPermiso(permisos, "replicar") && (idOtro.idOtro === "anamnesis" || idOtro.idOtro === "autorizacion") ? (
                        <Button icon="pi pi-copy" className="p-button-rounded p-button-warning p-mr-2" disabled={!replicar} tooltip="Copiar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }} onClick={() => copiar(rowData)} />
                    ) : (
                        ""
                    )}
                    {accionPermiso(permisos, "subir") ? <Button icon="pi pi-upload" className="p-button-rounded p-mr-2" style={{ backgroundColor: "#DA70D6", border: "1px solid #DA70D6", color: "#ffffff" }} disabled={!subir} tooltip="Subir" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }} onClick={() => dialogUpload(rowData)} /> : ""}
                    {accionPermiso(permisos, "descargar") ? (
                        <Button
                            icon="pi pi-download"
                            className="p-button-rounded p-mr-2"
                            style={{ backgroundColor: "#9370DB", border: "1px solid #9370DB", color: "#ffffff" }}
                            disabled={!elminar}
                            tooltip="Descargar"
                            tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
                            onClick={() => downloadFile(rowData)}
                        />
                    ) : (
                        ""
                    )}
                    {accionPermiso(permisos, "eliminar") ? (
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-mr-2" disabled={!elminar} tooltip="Eliminar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }} onClick={() => confirmDelete(rowData)} />
                    ) : (
                        ""
                    )}
                </div>
            </React.Fragment>
        );
    };

    const actionBodyStatus = (rowData) => {
        return (
            <div className="actions">
                <Knob value={50} size={33} />
            </div>
        );
    };

    const loadDataFormulario = async (row, editar) => {
        dispatch(loading(true));

        editar = editar ? (row.estado === 3 ? false : true) : false;

        var data = await getDataFormulario(usuario.token, row.id_otro_formulario);
        setini(ini + 1);
        if (data.error == 0) {
            dataFormulario.current["title"] = data.formulario;
            dataFormulario.current["pages"] = [];
            dataFormulario.current["id"] = row.id_otro_formulario;
            dataFormulario.current["editar"] = editar;
            data.grupo.map((grupo, index) => {
                let dat = {
                    label: grupo.grupo,
                    data: grupo.grupo_hijos,
                    data2: grupo.preguntas,
                    template: (item, options) => {
                        if (data.grupo.length < 2) {
                            return <span className="p-pt-5"></span>;
                        }

                        let paso = "PASO " + (index + 1);
                        let cssSpan = options.labelClassName + " p-m-0";
                        // <a className="p-menuitem-link p-mb-5" target={item.target} onClick={options.onClick}>
                        return (
                            <a className="p-menuitem-link p-mb-5" target={item.target} onClick={options.onClick}>
                                <Button type="button" className="p-button-rounded p-button-outlined p-m-1" tooltip={item.label} tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}>
                                    {" "}
                                    <span className={cssSpan}>{paso}</span>
                                </Button>
                            </a>
                        );
                    },
                };

                dataFormulario.current.pages.push(dat);
            });

            // setDataFormulario(dataFormulario);
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }

        dispatch(loading(false));
    };

    const dialogUpload = (row) => {
        rowData.current = row;
        setDisplayResponsive(true);
    };

    const onBasicUpload = () => {
        toast.current.show({ severity: "info", summary: "Success", detail: "File Uploaded with Basic Mode" });
    };

    const subirDocumento = async (files) => {
        setDisplayResponsive(false);
        dispatch(loading({ estado: true, mensaje: "Adjuntando Documento" }));
        var data = await uploadDocumentoOtros(usuario.token, rowData.current.id, idOtro.idOtro, files.files[0]);
        if (data.error == 0) {
            loadListaMatricula();
            toast.current.show({ severity: "success", summary: "OK", detail: "Documento subido con éxito!", life: 3000 });
            files.options.clear();
        } else {
            if (data.error == 1) {
                let msj = data.validacion[0].mensajes[0];
                toast.current.show({ severity: "error", summary: "Error", detail: msj, life: 3000 });
            } else {
                console.log("Error");
            }
        }

        dispatch(loading(false));
    }


    const statusDocumentoMasivoPDF = async (cargando) => {

        if (colegio.id !== undefined && anio.anio !== undefined) {

            if (cargando) dispatch(loading({ estado: true, mensaje: "Consultando status Documento PDF Masivo" }));
            var data = await statusDocumentoPDFMasivoOtros(usuario.token, colegio.id, anio.anio, idOtro.idOtro);
            if (data.error == 0) {
                setArray(data.data)
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
            if (cargando) dispatch(loading(false))
        }
    }

    const subirDocumentoMasivoPDF = async (files) => {
        dispatch(loading({ estado: true, mensaje: "Adjuntando Documento Masivo" }));
        var data = await uploadDocumentoPDFMasivoOtros(usuario.token, colegio.id, anio.anio, idOtro.idOtro, files.files[0]);
        if (data.error == 0) {
            setArray(data.data)
            toast.current.show({ severity: "success", summary: "OK", detail: "Documento subido con éxito!", life: 3000 });
            files.options.clear();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
        dispatch(loading(false));
    }

    const renderFooter = () => {
        return (
            <div>
                <Button label="Cerrar" icon="pi pi-times" onClick={() => setDisplayResponsive(false)} autoFocus />
            </div>
        );
    };

    const renderFooterPDF = () => {
        return (
            <div>
                <Button label="Cerrar" icon="pi pi-times" onClick={() => setDisplayResponsivePDF(false)} autoFocus />
            </div>
        );
    }

    const chooseOptions = { label: "Adjuntar" };
    const uploadOptions = { label: "Guardar", icon: "pi pi-upload", className: "p-button-success" };
    const cancelOptions = { label: "Cancelar", icon: "pi pi-times", className: "p-button-danger" };

    const htmlUpload = (
        <>
            <div className="p-col-12 p-md-12 p-lg-12 p-p-0">
                <div width="100%" style={{ textAlign: "left", width: "100%", border: "solid 1px", borderColor: "#dee2e6", padding: "10px", borderRadius: "5px" }}>
                    <span>{rowData.current == null ? "" : rowData.current.nombres + " " + rowData.current.apellido_paterno + " " + rowData.current.apellido_materno}</span>
                </div>
                <p></p>
                <div width="100%" style={{ textAlign: "center", width: "100%", border: "solid 1px", borderColor: "#dee2e6", padding: "10px", borderRadius: "5px" }}>
                    <FileUpload mode="basic" name="demo1" auto={false} customUpload={true} chooseOptions={chooseOptions} uploadOptions={uploadOptions} uploadHandler={subirDocumento} accept=".pdf,.jpg,.png" maxFileSize={1000000} onUpload={onBasicUpload} />
                </div>
            </div>
        </>
    )

    //const headerKeys = Object.keys(Object.assign({}, ...array));

    const headerKeys = ['Año', 'Archivo', 'Run', 'Estado', 'Mensaje', 'Fecha']

    const htmlUploadImportPDF = (
        <>
            <div className="p-col-12 p-md-12 p-lg-12 p-p-0">
                <div width="100%" style={{ textAlign: "left", width: "100%", border: "solid 1px", borderColor: "#dee2e6", padding: "10px", borderRadius: "5px" }}>
                    <span>
                        {colegio.rbd} : {colegio.nombre}
                    </span>
                </div>
                <p></p>
                {subir ? (
                    ""
                ) : (
                    <div width="100%" style={{ textAlign: "center", width: "100%", border: "solid 1px", borderColor: "#dee2e6", padding: "10px", borderRadius: "5px" }}>
                        <FileUpload mode="basic" name="demo12" auto={false} customUpload={true} chooseOptions={chooseOptions} uploadOptions={uploadOptions} uploadHandler={subirDocumentoMasivoPDF} accept="application/pdf" maxFileSize={25 * 1024 * 1024} />
                    </div>
                )}

                <ScrollPanel style={{ width: "100%", height: "200px" }} className="custombar2">
                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        <thead>
                            <tr key={"header"}>
                                {headerKeys.map((key) => (
                                    <th key={key} style={{ border: "solid 1px black" }}>{key}</th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {array.map((item, i) => (
                                <tr key={i}>
                                    {Object.values(item).map((val, index) => (
                                        <td key={index} style={{ border: "solid 1px black", textAlign: 'center', verticalAlign: 'middle' }}>
                                            {index === 3 ? (<Tag className="p-mr-2" severity={val == 1 ? "warning" : "success"} value={val == 1 ? "PENDIENTE" : "PROCESADO"}></Tag>) : (val)}
                                        </td>

                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </ScrollPanel>
            </div>
        </>
    );

    const saveMedico = async () => {
        setSubmitted(true);

        if (colegio.id !== undefined) {
            let validado = getResultValidar(medicoData, medicoDataValidate);
            setMedicoDataValidate(validado.result);

            let es_otro = false;
            if (medicoData.procedencia === "Otro") {
                if (inputAdd.value.trim() === "") {
                    let dd = inputAdd;
                    dd.estado = false;
                    setInputAdd({ ...dd });
                    validado.registra = false;
                } else {
                    es_otro = true;
                }
            }

            if (validado.registra) {
                dispatch(loading(true));
                let arrayIds = selectRow.map(function (item) {
                    return item.id_otro_formulario;
                });

                medicoData.data = arrayIds;
                var data = await setMedico(usuario.token, medicoData, es_otro, inputAdd.value.trim());

                if (data.error == 0) {
                    hideDialog();
                    loadListaMatricula();
                    toast.current.show({ severity: "success", summary: "OK", detail: "Registros guardados!", life: 3000 });
                } else {
                    if (data.error == 1) {
                        toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                    } else {
                        console.log("Error");
                    }
                }
                dispatch(loading(false));
            }
        }
    };

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || "";
        let _detalla = { ...medicoData };
        _detalla[`${name}`] = val;
        if (name === "procedencia") {
            if (val === "Otro") {
                setInputAdd({ value: inputAdd.value, enabled: false, estado: true });
            } else {
                setInputAdd({ value: "", enabled: true, estado: true });
            }
        }
        setMedicoData(_detalla);
    };

    const checkRows = (value) => {
        if (!idOtro.idOtro === "valoracion_salud") return true;
        /*
        if(rowData.current === null){
            toast.current.show({ severity: "error", summary: "Formulario no creado", detail: data.mensaje, life: 3000 });
            return false;
        }*/

        let array = [];
        let cerrados = false;
        value?.map((val, index) => {
            if (val.id_otro_formulario !== null) {
                array.push(val);
            } else {
                cerrados = true;
            }
        });

        if (idOtro.idOtro === "valoracion_salud" && cerrados) {
            toast.current.show({ severity: "error", summary: "Existen Formulario(s) no creado(s)", detail: data.mensaje, life: 3000 });
        }

        setSelectRow(array);
        setCountDelete(array.length);
    };

    const hideDialog = () => {
        setVisibleDialog(false);
        setSubmitted(false);
        setMedicoData({ ...medico });
    };

    const dialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Registrar" icon="pi pi-check" onClick={saveMedico} />
        </>
    );

    const isRowSelectable = (event) => {
        rowData.current = event.data.id_otro_formulario;
    };

    const bodyTemplateActivo = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                <Tag className="p-mr-2" severity={data[props.field] == 1 ? "success" : "warning"} value={data[props.field] == 1 ? "ACTIVO" : "RETIRADO"}></Tag>
            </>
        )
    }

    return (
        <div>
            <div className="p-grid table-demo" style={{ display: !visibleFudai ? "block" : "none" }}>
                <div className="p-col-12">
                    <Toast ref={toast} />
                    <DataTable
                        value={dataTableFilter}
                        selectionMode="checkbox"
                        paginator
                        id="13"
                        selection={selectRow}
                        onSelectionChange={(e) => checkRows(e.value)}
                        //onRowSelect={isRowSelectable}
                        className="p-datatable-customers p-datatable-sm"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Reg. {first} - {last} de {totalRecords}"
                        rowsPerPageOptions={[5, 10, 25]}
                        rows={8}
                        dataKey="id"
                        rowHover
                        globalFilter={globalFilter}
                        emptyMessage="No existe información!"
                        loading={false}
                        header={dataTableHeader}
                        size="small"
                        responsiveLayout="scroll"
                    >
                        {/*  <Column field="fecha_matricula" header="Fecha Matricula" sortable body={bodyTemplateDate} ></Column>*/}
                        {/*  <Column field="rbd" header="Rbd" sortable body={bodyTemplate} ></Column> */}
                        {idOtro.idOtro === "valoracion_salud" ? <Column selectionMode="multiple" headerStyle={{ width: "3em" }}></Column> : <Column headerStyle={{ width: "0em" }}></Column>}
                        <Column field="cod_ensenanza" headerStyle={{ width: "3.5rem" }} bodyStyle={{ textAlign: "center"}} header="Código" body={bodyTemplate}></Column>
                        <Column field="grado" headerStyle={{ width: "4rem"}} bodyStyle={{ textAlign: "center" }}  header="Curso" body={bodyTemplate}></Column>
                        <Column headerStyle={{ width: "9rem"}} field="run" header="Run" sortable body={bodyTemplate}></Column>
                        <Column field="nombres" header="Nombres" sortable body={bodyTemplate}></Column>
                        <Column field="apellido_paterno" header="Paterno" sortable body={bodyTemplate}></Column>
                        <Column field="apellido_materno" header="Materno" sortable body={bodyTemplate}></Column>
                        <Column field="estado_alumno" headerStyle={{ width: "6rem" }} header="Estado" sortable body={bodyTemplateActivo}></Column>
                        <Column headerStyle={{ textAlign: "center" }} field="diagnostico" header="Diagnóstico" sortable body={bodyTemplate}></Column>

                        <Column header="Herramientas" headerStyle={{ width: "25em", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible", justifyContent: "center" }} body={actionBodyHerramienta}></Column>
                    </DataTable>
                    <Dialog header="Subir Archivo" visible={displayResponsive} onHide={() => setDisplayResponsive(false)} breakpoints={{ "960px": "75vw" }} style={{ width: "35vw" }} footer={renderFooter()}>
                        {htmlUpload}
                    </Dialog>
                    <Dialog header="Importar PDF Masivo" visible={displayResponsivePDF} onHide={() => setDisplayResponsivePDF(false)} breakpoints={{ "960px": "75vw" }} style={{ width: "60vw" }} footer={renderFooterPDF()}>
                        {htmlUploadImportPDF}
                    </Dialog>
                    <Dialog visible={visibleDialog} style={{ width: "45vw" }} breakpoints={{ "960px": "100vw" }} header="IDENTIFICACIÓN DEL PERSONAL - MÉDICO" modal className="p-fluid" footer={dialogFooter} onHide={hideDialog}>
                        <div className="p-formgrid p-grid p-col-12 p-p-0 p-mt-0">
                            <div className="p-col-12 p-md-8 p-lg-8 p-mt-2">
                                <label htmlFor="name2">Nombres y Apellidos</label>
                                <InputText value={medicoData.nombres} onChange={(e) => onInputChange(e, "nombres")} required className={classNames({ "p-invalid": submitted && !medicoDataValidate.nombres.estado })} />
                                {submitted && !medicoDataValidate.nombres.estado && <small className="p-error">{medicoDataValidate.nombres.mensaje}</small>}
                            </div>
                            <div className="p-col-12 p-md-4 p-lg-4 p-mt-2">
                                <label htmlFor="name2">Rut</label>
                                <InputText value={medicoData.rut} onChange={(e) => onInputChange(e, "rut")} required className={classNames({ "p-invalid": submitted && !medicoDataValidate.rut.estado })} />
                                {submitted && !medicoDataValidate.rut.estado && <small className="p-error">{medicoDataValidate.rut.mensaje}</small>}
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                                <label htmlFor="name2">No Registro Profesional</label>
                                <InputText value={medicoData.nro_reg_prof} onChange={(e) => onInputChange(e, "nro_reg_prof")} required className={classNames({ "p-invalid": submitted && !medicoDataValidate.nro_reg_prof.estado })} />
                                {submitted && !medicoDataValidate.nro_reg_prof.estado && <small className="p-error">{medicoDataValidate.nro_reg_prof.mensaje}</small>}
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                                <label htmlFor="name2">Especialidad</label>
                                <InputText value={medicoData.especialidad} onChange={(e) => onInputChange(e, "especialidad")} required className={classNames({ "p-invalid": submitted && !medicoDataValidate.especialidad.estado })} />
                                {submitted && !medicoDataValidate.especialidad.estado && <small className="p-error">{medicoDataValidate.especialidad.mensaje}</small>}
                            </div>
                            <div className="p-col-12 p-md-4 p-lg-4 p-mt-2">
                                <label htmlFor="name2">Procedencia</label>
                                <br></br>
                                {submitted && !medicoDataValidate.procedencia.estado && <small className="p-error">{medicoDataValidate.procedencia.mensaje}</small>}
                                <div className="field-radiobutton p-mt-2">
                                    <RadioButton inputId="city1" name="city" value="Salud Pública" onChange={(e) => onInputChange(e, "procedencia")} checked={medicoData.procedencia === "Salud Pública"} />
                                    <label className="p-ml-1" htmlFor="city1">
                                        Salud Pública
                                    </label>
                                </div>
                                <div className="field-radiobutton p-mt-2">
                                    <RadioButton inputId="city2" name="city" value="Particular" onChange={(e) => onInputChange(e, "procedencia")} checked={medicoData.procedencia === "Particular"} />
                                    <label className="p-ml-1" htmlFor="city2">
                                        Particular
                                    </label>
                                </div>
                                <div className="field-radiobutton p-mt-2">
                                    <RadioButton inputId="city3" name="city" value="Escuela" onChange={(e) => onInputChange(e, "procedencia")} checked={medicoData.procedencia === "Escuela"} />
                                    <label className="p-ml-1" htmlFor="city3">
                                        Escuela
                                    </label>
                                </div>
                                <div className="field-radiobutton p-mt-2">
                                    <RadioButton inputId="city4" name="city" value="Otro" onChange={(e) => onInputChange(e, "procedencia")} checked={medicoData.procedencia === "Otro"} />
                                    <label className="p-ml-1" htmlFor="city4">
                                        Otro
                                    </label>
                                </div>
                            </div>

                            <div className="p-col-12 p-md-8 p-lg-8 p-mt-2 p-ml-0 p-grid p-align-end vertical-container">
                                <InputText value={inputAdd.value} disabled={inputAdd.enabled} onChange={(e) => setInputAdd({ value: e.target.value, enabled: false, estado: true })} required className={classNames({ "p-invalid": !inputAdd.estado })} />
                            </div>
                            <div className="p-col-12 p-md-4 p-lg-4 p-mt-2">
                                <label htmlFor="name2">Fono/E-mail contacto </label>
                                <InputText value={medicoData.fono_email} onChange={(e) => onInputChange(e, "fono_email")} required className={classNames({ "p-invalid": submitted && !medicoDataValidate.fono_email.estado })} />
                                {submitted && !medicoDataValidate.fono_email.estado && <small className="p-error">{medicoDataValidate.fono_email.mensaje}</small>}
                            </div>
                            <div className="p-col-12 p-md-4 p-lg-4 p-mt-2">
                                <label htmlFor="name2">Fecha evaluación</label>
                                <Calendar
                                    id="spanish"
                                    value={medicoData.fecha_eval}
                                    onChange={(e) => onInputChange(e, "fecha_eval")}
                                    locale="es"
                                    dateFormat="dd/mm/yy"
                                    monthNavigator
                                    yearNavigator
                                    yearRange="2020:2030"
                                    showIcon
                                    monthNavigatorTemplate={monthNavigatorTemplate}
                                    yearNavigatorTemplate={yearNavigatorTemplate}
                                />
                                {submitted && !medicoDataValidate.fecha_eval.estado && <small className="p-error">{medicoDataValidate.fecha_eval.mensaje}</small>}
                            </div>
                            <div className="p-col-12 p-md-4 p-lg-4 p-mt-2">
                                <label htmlFor="name2">Fecha reevaluación</label>
                                <Calendar
                                    id="spanish"
                                    value={medicoData.fecha_rev}
                                    onChange={(e) => onInputChange(e, "fecha_rev")}
                                    locale="es"
                                    dateFormat="dd/mm/yy"
                                    monthNavigator
                                    yearNavigator
                                    yearRange="2020:2030"
                                    showIcon
                                    monthNavigatorTemplate={monthNavigatorTemplate}
                                    yearNavigatorTemplate={yearNavigatorTemplate}
                                />
                                {submitted && !medicoDataValidate.fecha_rev.estado && <small className="p-error">{medicoDataValidate.fecha_rev.mensaje}</small>}
                            </div>
                        </div>
                    </Dialog>
                </div>
            </div>

            <div className="p-grid table-demo">
                <div className="p-col-12">
                    <div
                        className="steps-demo"
                        style={{
                            opacity: visibleFudai ? "1" : "0",
                            transition: visibleFudai ? "all .9s" : "all .0s",
                            height: visibleFudai ? "auto" : 0,
                            visibility: visibleFudai ? "block" : "none",
                        }}
                    >
                        <div className="card">
                            <div className="p-grid">
                                <div className="p-col-fixed" style={{ width: "50px" }}>
                                    <div className="box">
                                        <Button icon="pi pi-arrow-left" className="p-button-rounded" onClick={hideFormulario} />
                                    </div>
                                </div>
                                <div className="p-col">
                                    <div className="box">
                                        <h5>
                                            {dataFormulario.current["title"]} {data.current === null ? "" : data.current.nombres + " " + data.current.apellido_paterno + " " + data.current.apellido_materno + " (" + data.current.nivel_seccion + ") - " + data.current.nombre_formulario}
                                        </h5>
                                        {data.current === null ? "" : <div style={{ fontSize: "16px", textAlign: "center" }}>{data.current.titulo1_reevaluacion}</div>}
                                        {data.current === null ? "" : <div style={{ fontSize: "16px", textAlign: "center" }}>{data.current.titulo2_reevaluacion}</div>}
                                    </div>
                                </div>
                            </div>
                            <Steps model={dataFormulario.current.pages} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={false} />

                            {dataFormulario.current.pages?.map((page, index) => {
                                return (
                                    <Formulario
                                        key={index}
                                        ini={ini}
                                        active={activeIndex == index ? true : false}
                                        data={page.data}
                                        preguntas={page.data2}
                                        label={page.label}
                                        id={dataFormulario.current["id"]}
                                        final={dataFormulario.current.pages.length == index + 1}
                                        editar={dataFormulario.current["editar"]}
                                        otroFormulario={true}
                                        cerrar={cerrar}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
